import { render, staticRenderFns } from "./VestDetail.vue?vue&type=template&id=582e996e&scoped=true&"
import script from "./VestDetail.vue?vue&type=script&lang=js&"
export * from "./VestDetail.vue?vue&type=script&lang=js&"
import style0 from "./VestDetail.vue?vue&type=style&index=0&id=582e996e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582e996e",
  null
  
)

export default component.exports